<template>
    <div class="auth-mask position-absolute vw-100 vh-100">
        <b-row class="justify-content-center vw-100 vh-100">
            <b-col sm="6" class="px-5 align-self-center">
                <b-button block variant="outline-info" @click="login">Login with Google</b-button>
<!--
                <b-button block variant="primary" @click="register">Register</b-button>
-->
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    components: {
    },
    methods: {
        login () {
            window.location.href = '/auth/redirect'
        },
//        register () {
//            window.location.href = '/auth/redirect'
//        },
    },
}
</script>

<style>
.auth-mask {
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    background: #fff;
}
</style>
